import _get from 'lodash/get';
import _head from 'lodash/head';
/**
 * make coupon product factory
 * @param {Function} convertAndFormat convert and format price util
 * @returns {Function} couponProductFactory
 */
export function makeCouponProductFactory(convertAndFormat) {
  if (convertAndFormat === void 0) {
    convertAndFormat = function convertAndFormat(x) {
      return x;
    };
  }
  /**
   * coupon product factory
   * @param {Object} coupon plain unformatted coupon product from cart's products
   * @returns {Object} formatted coupon product
   */
  return function couponProductFactory(coupon) {
    var totalPrice = _get(coupon, 'price.total', 0);
    var totalWithVat = _get(coupon, 'price.totalWithVat', 0);
    return {
      name: _get(coupon, 'name'),
      description: _get(coupon, 'description'),
      totalPrice: totalPrice,
      totalWithVat: totalWithVat,
      displayedTotalWithVat: convertAndFormat(totalWithVat),
      displayedTotalPrice: convertAndFormat(totalPrice),
      displayedCurrency: _get(coupon, 'displayPrice.currency'),
      code: _get(coupon, 'code', ''),
      isValid: !(coupon !== null && coupon !== void 0 && coupon.notes) || [].some(function (n) {
        return n.type === 'error';
      }),
      errorMessage: _get(_head((coupon === null || coupon === void 0 ? void 0 : coupon.notes) || [].filter(function (n) {
        return n.type === 'error';
      })), 'message', '')
    };
  };
}